import React from "react";

export default () => <>Not Found</>;
